import { Text } from "@aurem/ui";
import { Download } from "lucide-react";
import type { FC } from "react";

import { FindThreadQuery } from "types";
import { formatFileSize } from "utils/helpers";
import { TypewriterText } from "./StreamingIndicator";

type AssistantMessageMetadata = Extract<
  NonNullable<
    FindThreadQuery["findThread"]["messagesList"][number]["metadata"]
  >,
  { __typename: "AssistantMessageMetadata" }
>;
type DatabaseExportResult = Extract<
  AssistantMessageMetadata["result"]["result"],
  { __typename: "DatabaseExportResult" }
>;
interface ExportCardProps {
  reply: DatabaseExportResult;
  exportUrl: string;
  exportFilename: string;
  exportSize: string;
  isStreaming?: boolean;
}

export const ExportCard: FC<ExportCardProps> = ({
  reply,
  exportUrl,
  exportFilename,
  exportSize,
  isStreaming = false,
}) => {
  if (isStreaming) {
    return (
      <div className="space-y-3">
        {reply.reasoning && (
          <TypewriterText
            text={reply.reasoning}
            isComplete={false}
            showCursor={true}
          />
        )}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {reply.reasoning && (
        <Text size="sm" className="text-neutral-500 leading-relaxed ">
          {reply.reasoning}
        </Text>
      )}
      <a
        href={exportUrl}
        download={exportFilename}
        className="block rounded-lg border border-neutral-500/10 bg-white shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer p-2"
      >
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0 flex-1">
            <Text className="font-medium break-words">{exportFilename}</Text>
            <Text className="text-xs text-neutral-500/50">{reply.summary}</Text>
            <Text size="xs" className="text-neutral-500/50 mt-1">
              {!isNaN(Number(exportSize))
                ? formatFileSize(Number(exportSize))
                : exportSize}
            </Text>
          </div>
          <div className="p-3 rounded shrink-0">
            <Download size={16} />
          </div>
        </div>
      </a>
    </div>
  );
};
